export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10705.b6e3e4a8.jpg";